import { array, object, string } from "yup";

export const areaValidationSchema = object({
  name: string().required("Field is required!"),
  postcodes: array()
    .of(string())
    .min(1, "Select at least one postcode!")
    .required("Select at least one postcode!"),
});
